<template>
  <Transition name="record-expenses-overlay">
    <div
      v-if="isOpen"
      class="record-expenses-modal-overlay record-expenses-modal-overlay--glass"
      @click.self="closeModal"
    >
      <Transition name="record-expenses-panel" appear>
        <div
          class="record-expenses-modal record-expenses-modal--glass"
          role="dialog"
          aria-labelledby="record-expenses-modal-title"
          @click.stop
        >
          <div class="record-expenses-modal-header record-expenses-modal-header--glass">
            <h2 id="record-expenses-modal-title" class="record-expenses-modal-title">
              <i class="bi bi-wallet2 record-expenses-modal-title__icon" aria-hidden="true"></i>
              Record Expenses
            </h2>
            <div class="record-expenses-modal-header-actions">
              <button
                type="button"
                class="record-expenses-icon-btn"
                aria-label="Help"
                title="Help"
                @click="$emit('help')"
              >
                <i class="bi bi-question-circle" aria-hidden="true"></i>
              </button>
              <button
                type="button"
                class="record-expenses-icon-btn record-expenses-icon-btn--close"
                aria-label="Close"
                title="Close"
                @click="closeModal"
              >
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div class="record-expenses-modal-body record-expenses-modal-body--glass">
            <div class="record-expenses-options" role="radiogroup" aria-label="Expense type options">
              <label
                v-for="(option, index) in expenseTypeOptions"
                :key="option.value"
                class="record-expenses-radio-option"
                :class="{
                  selected: selectedType === option.value,
                  [`record-expenses-radio-option--${index + 1}`]: true,
                }"
              >
                <input
                  type="radio"
                  v-model="selectedType"
                  :value="option.value"
                  name="expenseType"
                />
                <div class="record-expenses-option-content">
                  <span class="record-expenses-radio-control" aria-hidden="true"></span>
                  <i v-if="option.icon" :class="option.icon" class="record-expenses-option-icon" aria-hidden="true"></i>
                  <span class="record-expenses-radio-label">{{ option.label }}</span>
                </div>
              </label>
            </div>
          </div>

          <div class="record-expenses-modal-footer record-expenses-modal-footer--glass">
            <SecondaryButton label="Cancel" icon="" @click="closeModal" />
            <PrimaryButton label="Continue" icon="bi bi-arrow-right" @click="ok" />
          </div>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script>
import './RecordExpensesModal.css';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'RecordExpensesModal',
  components: { PrimaryButton, SecondaryButton },
  data() {
    return {
      isOpen: true,
      selectedType: 'Credit Card',
      expenseTypeOptions: [
        { value: 'Credit Card', label: 'Credit Card', icon: 'bi bi-credit-card' },
        { value: 'Cash', label: 'Cash', icon: 'bi bi-cash-stack' },
      ],
    };
  },
  methods: {
    closeModal() {
      if (!this.isOpen) return;
      this.isOpen = false;
      window.setTimeout(() => {
        this.$emit('close');
      }, 300);
    },
    ok() {
      if (this.selectedType === 'Credit Card') {
        const companyId = this.$route.params.id;
        this.$router.push({
          name: 'VendorCreditCardExpense',
          params: { id: companyId },
        });
      } else if (this.selectedType === 'Cash') {
        const companyId = this.$route.params.id;
        this.$router.push({
          name: 'VendorCashExpense',
          params: { id: companyId },
        });
      }
      this.$emit('ok', this.selectedType);
      this.closeModal();
    },
  },
};
</script>
